import { lazy, type ComponentType } from "react";
import type { LibraryProps } from "@/components/variations/books";
import { DesignShell } from "./design-shell";

const libraries: Record<string, ComponentType<LibraryProps>> = {
  v1: lazy(() =>
    import("@/components/variations/v1/V1Library").then((m) => ({
      default: m.V1Library,
    })),
  ),
  v2: lazy(() =>
    import("@/components/variations/v2/V2Library").then((m) => ({
      default: m.V2Library,
    })),
  ),
  v3: lazy(() =>
    import("@/components/variations/v3/V3Library").then((m) => ({
      default: m.V3Library,
    })),
  ),
  v4: lazy(() =>
    import("@/components/variations/v4/V4Library").then((m) => ({
      default: m.V4Library,
    })),
  ),
  v5: lazy(() =>
    import("@/components/variations/v5/V5Library").then((m) => ({
      default: m.V5Library,
    })),
  ),
  v6: lazy(() =>
    import("@/components/variations/v6/V6Library").then((m) => ({
      default: m.V6Library,
    })),
  ),
  v7: lazy(() =>
    import("@/components/variations/v7/V7Library").then((m) => ({
      default: m.V7Library,
    })),
  ),
  v8: lazy(() =>
    import("@/components/variations/v8/V8Library").then((m) => ({
      default: m.V8Library,
    })),
  ),
  v9: lazy(() =>
    import("@/components/variations/v9/V9Library").then((m) => ({
      default: m.V9Library,
    })),
  ),
};

export function LibraryShell(props: LibraryProps) {
  return <DesignShell componentMap={libraries} componentProps={props} />;
}
